import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectOption } from '../actions/index';
import { Link } from 'react-router-dom'; // Importez Link

class OptionList extends Component {
  createListItems() {
    return this.props.options.map((option) => {
      return (
        <li className='left-option' key={option.id} id={option.url ? option.url : 'dashboard'}>
          <Link to={`/${option.url}`}>{option.name}</Link>
        </li>
      );
    });
  }

  render() {
    return <ul className='left-options'>{this.createListItems()}</ul>;
  }
}

function mapStateToProps(state) {
  return {
    options: state.options,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ selectOption }, dispatch);
}

const ConnectedOptionList = connect(
  mapStateToProps,
  matchDispatchToProps
)(OptionList);

export default ConnectedOptionList;
